var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "risk-assessment scroll-form",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text fixed-header",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.powra.pointOfWorkRiskAssessment').toUpperCase()) + "\n      ")]), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('PowraTitle', {
    attrs: {
      "avatar": 'B',
      "title": _vm.$vuetify.t('$vuetify.powra.meansOfAccessToWorkArea')
    }
  }), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-2": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-2",
    attrs: {
      "label": _vm.$vuetify.t('$vuetify.powra.mobileScaffoldTower'),
      "color": "green"
    },
    model: {
      value: _vm.mobileScaffoldTower,
      callback: function callback($$v) {
        _vm.mobileScaffoldTower = $$v;
      },
      expression: "mobileScaffoldTower"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 py-0",
    attrs: {
      "label": _vm.$vuetify.t('$vuetify.powra.MEWP'),
      "color": "green"
    },
    model: {
      value: _vm.MEWP,
      callback: function callback($$v) {
        _vm.MEWP = $$v;
      },
      expression: "MEWP"
    }
  })], 1), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 py-0",
    attrs: {
      "label": _vm.$vuetify.t('$vuetify.powra.trestlesStaging'),
      "color": "green"
    },
    model: {
      value: _vm.trestlesStaging,
      callback: function callback($$v) {
        _vm.trestlesStaging = $$v;
      },
      expression: "trestlesStaging"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 py-0",
    attrs: {
      "label": _vm.$vuetify.t('$vuetify.powra.podiumSteps'),
      "color": "green"
    },
    model: {
      value: _vm.podiumSteps,
      callback: function callback($$v) {
        _vm.podiumSteps = $$v;
      },
      expression: "podiumSteps"
    }
  })], 1), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 py-0",
    attrs: {
      "label": _vm.$vuetify.t('$vuetify.powra.stepLadder'),
      "color": "green"
    },
    model: {
      value: _vm.stepLadder,
      callback: function callback($$v) {
        _vm.stepLadder = $$v;
      },
      expression: "stepLadder"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 py-0",
    attrs: {
      "label": _vm.$vuetify.t('$vuetify.powra.extensionLadder'),
      "color": "green"
    },
    model: {
      value: _vm.extensionLadder,
      callback: function callback($$v) {
        _vm.extensionLadder = $$v;
      },
      expression: "extensionLadder"
    }
  })], 1), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 py-0",
    attrs: {
      "label": _vm.$vuetify.t('$vuetify.powra.suspendedAccess'),
      "color": "green"
    },
    model: {
      value: _vm.suspendedAccess,
      callback: function callback($$v) {
        _vm.suspendedAccess = $$v;
      },
      expression: "suspendedAccess"
    }
  })], 1)], 1)], 1), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "px-3": "",
      "pt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": _vm.$vuetify.t('$vuetify.powra.other')
    },
    model: {
      value: _vm.other,
      callback: function callback($$v) {
        _vm.other = $$v;
      },
      expression: "other"
    }
  })], 1)], 1), _c('div', {
    staticClass: "footer text-xs-center mb-3"
  }, [_c('v-divider'), _c('v-card-text', [_c('v-btn', {
    on: {
      "click": function click($event) {
        return _vm.back();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.back')) + "\n          ")]), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.confirm();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.proceedToTheNextSection')) + "\n          ")]), _c('abort-visit', {
    on: {
      "aborted": function aborted($event) {
        return _vm.visitAborted();
      }
    }
  })], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }